import React, { useState, useEffect } from 'react';
import { GetRequest } from 'components/common';
import QuoteBuilderForm from 'components/quote_builder/QuoteBuilderForm.jsx';

// The price (UserUnitPrice) CREATE form for `priceKey`, opened straight on a new record. When `attributeId` is
// given, that machine attribute is pre-selected on the reference field (whose config.key is `contextKey`, via
// QuoteBuilderForm's context mechanism -- UserUnitPriceAttributeField) -- the just-copied machine. When it is
// OMITTED, no context is passed, so the field auto-selects the owner's first existing machine of this key: this
// is the "price a machine you already have" step, where the machine exists but has no price yet. The big price
// config is fetched on demand by key. Rendered in place by LibraryAttributePicker as the price step once a
// machine is copied (settings page, /mcc manage popup, /mcc inline add-machine flow) and by the wizard's
// machine-price step.
const UserUnitPriceCreateForm = ({ priceKey, contextKey, attributeId, afterSave, afterCancel, hideButtons, submitRef, onSaveError }) => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    GetRequest({
      url: `/quote-builder/config/settings/user_unit_prices/${priceKey}`,
      callback: (data) => { setConfig(data); },
    });
  }, [priceKey]);

  if (!config) { return <div className="library-picker__status">{t('quote_builder.please_wait')}</div>; }

  // No attributeId -> no context, so the reference field falls back to auto-selecting the first existing machine
  // (see UserUnitPriceAttributeField). Passing { [contextKey]: undefined } would instead UNSET that auto-select.
  const context = attributeId != null ? { [contextKey]: attributeId } : undefined;

  // hideButtons drops the form's OWN Save and Cancel (a local config edit, so it never touches the shared form or
  // any other embedder): in the setup wizard the form has no buttons of its own -- the wizard's Next saves it
  // (via submitRef) and its Back cancels. The picker's price step leaves them on, driven by its own Save/Cancel.
  const formConfig = hideButtons
    ? { ...config, submit: { ...config.submit, enabled: false }, cancel: { ...config.cancel, enabled: false } }
    : config;

  return (
    <QuoteBuilderForm
      config={formConfig}
      showingState="new"
      context={context}
      afterSave={afterSave}
      afterCancel={afterCancel}
      submitRef={submitRef}
      onSaveError={onSaveError}
    />
  );
};

export default UserUnitPriceCreateForm;
